import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LISTE_BASLIKLAR = {
  evrak_listesi: 'Evrak Listesi',
  ek_menfaatler: 'Ek Menfaatler',
  surec_adimlari: 'Süreç Adımları',
  emeklilik_durumu: 'Emeklilik Durumu Seçenekleri',
};

const IcerikYonetimiPage = () => {
  const [sekme, setSekme] = useState('sayfalar');
  const [sayfaMetinleri, setSayfaMetinleri] = useState([]);
  const [dinamikListeler, setDinamikListeler] = useState([]);
  const [seciliSayfa, setSeciliSayfa] = useState(null);
  const [seciliListe, setSeciliListe] = useState(null);
  const [duzenleId, setDuzenleId] = useState(null);
  const [duzenleForm, setDuzenleForm] = useState({});
  const [yeniOgeForm, setYeniOgeForm] = useState({ etiket: '', aciklama: '' });
  const [yeniOgePanel, setYeniOgePanel] = useState(false);
  const [sonuc, setSonuc] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = async () => {
    const [m, l] = await Promise.all([
      axios.get('/api/admin/sayfa-metinleri').then(r => r.data),
      axios.get('/api/admin/dinamik-listeler').then(r => r.data),
    ]);
    setSayfaMetinleri(m);
    setDinamikListeler(l);
  };
  useEffect(() => { yukle(); }, []);

  // Sayfaları grupla
  const sayfalar = [...new Set(sayfaMetinleri.map(m => m.sayfa_anahtar))].map(anahtar => ({
    anahtar,
    baslik: sayfaMetinleri.find(m => m.sayfa_anahtar === anahtar)?.sayfa_baslik || anahtar
  }));

  // Listeleri grupla
  const listeler = [...new Set(dinamikListeler.map(l => l.liste_anahtar))].map(anahtar => ({
    anahtar,
    baslik: LISTE_BASLIKLAR[anahtar] || anahtar
  }));

  const metinKaydet = async (id, deger) => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/admin/sayfa-metinleri/' + id, { deger });
      setSonuc({ tip: 'basari', mesaj: 'Kaydedildi.' });
      setDuzenleId(null);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const metinSifirla = async (id) => {
    if (!window.confirm('Varsayılan değere döndürülsün mü?')) return;
    await axios.post('/api/admin/sayfa-metinleri/sifirla/' + id);
    yukle();
  };

  const listeSatirKaydet = async (id) => {
    setYukleniyor(true); setSonuc(null);
    try {
      await axios.put('/api/admin/dinamik-listeler/' + id, duzenleForm);
      setSonuc({ tip: 'basari', mesaj: 'Kaydedildi.' });
      setDuzenleId(null);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: 'Hata oluştu.' }); }
    finally { setYukleniyor(false); }
  };

  const listeSatirSil = async (id) => {
    if (!window.confirm('Silmek istediğinize emin misiniz?')) return;
    await axios.delete('/api/admin/dinamik-listeler/' + id);
    yukle();
  };

  const yeniOgeEkle = async () => {
    if (!yeniOgeForm.etiket) return;
    setYukleniyor(true);
    try {
      const deger = yeniOgeForm.etiket.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
      await axios.post('/api/admin/dinamik-listeler', {
        liste_anahtar: seciliListe,
        liste_baslik: LISTE_BASLIKLAR[seciliListe] || seciliListe,
        deger,
        etiket: yeniOgeForm.etiket,
        aciklama: yeniOgeForm.aciklama,
        sira: dinamikListeler.filter(l => l.liste_anahtar === seciliListe).length + 1
      });
      setYeniOgeForm({ etiket: '', aciklama: '' });
      setYeniOgePanel(false);
      yukle();
    } catch(err) { setSonuc({ tip: 'hata', mesaj: 'Eklenemedi.' }); }
    finally { setYukleniyor(false); }
  };

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>İçerik Yönetimi</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Sayfa metinlerini ve dinamik listeleri kod değişikliği yapmadan düzenleyin.</p>
      </div>

      {sonuc && <div className={'alert alert-' + (sonuc.tip === 'basari' ? 'success' : 'error')} style={{ marginBottom: '1rem' }}>{sonuc.mesaj}</div>}

      {/* Sekmeler */}
      <div style={{ display: 'flex', borderBottom: '1px solid var(--border)', marginBottom: '1.5rem' }}>
        {[{ key: 'sayfalar', label: 'Sayfa Yönetimi' }, { key: 'listeler', label: 'Sistem Yapılandırması' }].map(s => (
          <button key={s.key} onClick={() => { setSekme(s.key); setSeciliSayfa(null); setSeciliListe(null); setDuzenleId(null); }}
            style={{ padding: '0.6rem 1.25rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: sekme === s.key ? '600' : '400', color: sekme === s.key ? 'var(--mavi)' : 'var(--yazi-ikincil)', borderBottom: sekme === s.key ? '2px solid var(--mavi)' : '2px solid transparent' }}>
            {s.label}
          </button>
        ))}
      </div>

      {sekme === 'sayfalar' && (
        <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: '1.5rem', alignItems: 'start' }}>
          {/* Sol - Sayfa Listesi */}
          <div className="card" style={{ padding: '0.75rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.5rem', padding: '0 0.25rem' }}>Sayfalar</p>
            {sayfalar.map(s => (
              <button key={s.anahtar} onClick={() => { setSeciliSayfa(s.anahtar); setDuzenleId(null); }}
                style={{ width: '100%', textAlign: 'left', padding: '0.5rem 0.75rem', border: 'none', borderRadius: 'var(--radius-sm)', cursor: 'pointer', background: seciliSayfa === s.anahtar ? 'var(--mavi-acik)' : 'transparent', color: seciliSayfa === s.anahtar ? 'var(--mavi)' : 'var(--yazi)', fontSize: '13px', fontWeight: seciliSayfa === s.anahtar ? '500' : '400', marginBottom: '2px', display: 'block' }}>
                {s.baslik}
              </button>
            ))}
          </div>

          {/* Sağ - Metin Alanları */}
          {seciliSayfa ? (
            <div className="card">
              <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
                <h3 style={{ fontSize: '16px', fontFamily: 'DM Sans', fontWeight: '600' }}>
                  {sayfalar.find(s => s.anahtar === seciliSayfa)?.baslik} — Metinler
                </h3>
                <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '4px' }}>Düzenlemek için kaleme tıklayın. Sıfırla ile varsayılan değere dönebilirsiniz.</p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {sayfaMetinleri.filter(m => m.sayfa_anahtar === seciliSayfa).map(m => (
                  <div key={m.id} style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                      <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{m.alan_baslik}</span>
                      <div style={{ display: 'flex', gap: '6px' }}>
                        {duzenleId === m.id ? (
                          <>
                            <button className="btn btn-primary btn-sm" disabled={yukleniyor} onClick={() => metinKaydet(m.id, duzenleForm.deger)}>Kaydet</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => setDuzenleId(null)}>İptal</button>
                          </>
                        ) : (
                          <>
                            <button className="btn btn-secondary btn-sm" onClick={() => { setDuzenleId(m.id); setDuzenleForm({ deger: m.deger }); }}>✏️ Düzenle</button>
                            <button className="btn btn-secondary btn-sm" onClick={() => metinSifirla(m.id)}>↺ Sıfırla</button>
                          </>
                        )}
                      </div>
                    </div>
                    {duzenleId === m.id ? (
                      <textarea value={duzenleForm.deger} onChange={e => setDuzenleForm({ deger: e.target.value })} rows={2} style={{ width: '100%', fontSize: '14px' }} />
                    ) : (
                      <p style={{ fontSize: '14px', color: 'var(--yazi)' }}>{m.deger}</p>
                    )}
                    {m.deger !== m.varsayilan && <p style={{ fontSize: '11px', color: 'var(--sari)', marginTop: '4px' }}>⚠ Varsayılandan farklı</p>}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="card" style={{ textAlign: 'center', padding: '3rem', color: 'var(--yazi-ikincil)' }}>
              Soldan bir sayfa seçin.
            </div>
          )}
        </div>
      )}

      {sekme === 'listeler' && (
        <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: '1.5rem', alignItems: 'start' }}>
          {/* Sol - Liste Grupları */}
          <div className="card" style={{ padding: '0.75rem' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.5rem', padding: '0 0.25rem' }}>Listeler</p>
            {listeler.map(l => (
              <button key={l.anahtar} onClick={() => { setSeciliListe(l.anahtar); setDuzenleId(null); setYeniOgePanel(false); }}
                style={{ width: '100%', textAlign: 'left', padding: '0.5rem 0.75rem', border: 'none', borderRadius: 'var(--radius-sm)', cursor: 'pointer', background: seciliListe === l.anahtar ? 'var(--mavi-acik)' : 'transparent', color: seciliListe === l.anahtar ? 'var(--mavi)' : 'var(--yazi)', fontSize: '13px', fontWeight: seciliListe === l.anahtar ? '500' : '400', marginBottom: '2px', display: 'block' }}>
                {l.baslik}
              </button>
            ))}
          </div>

          {/* Sağ - Liste Ögeleri */}
          {seciliListe ? (
            <div className="card">
              <div style={{ marginBottom: '1.25rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h3 style={{ fontSize: '16px', fontFamily: 'DM Sans', fontWeight: '600' }}>{LISTE_BASLIKLAR[seciliListe] || seciliListe}</h3>
                  <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '4px' }}>Ögeleri düzenleyin, silin veya yeni öge ekleyin.</p>
                </div>
                <button className="btn btn-primary btn-sm" onClick={() => setYeniOgePanel(!yeniOgePanel)}>+ Yeni Öge</button>
              </div>

              {/* Yeni öge formu */}
              {yeniOgePanel && (
                <div style={{ background: 'var(--gri-50)', borderRadius: 'var(--radius-sm)', padding: '1rem', marginBottom: '1rem' }}>
                  <p style={{ fontSize: '13px', fontWeight: '600', marginBottom: '0.75rem' }}>Yeni Öge Ekle</p>
                  <div className="form-grid">
                    <div className="form-group"><label>Etiket *</label><input type="text" value={yeniOgeForm.etiket} onChange={e => setYeniOgeForm({ ...yeniOgeForm, etiket: e.target.value })} placeholder="Görünen isim" /></div>
                    <div className="form-group"><label>Açıklama</label><input type="text" value={yeniOgeForm.aciklama} onChange={e => setYeniOgeForm({ ...yeniOgeForm, aciklama: e.target.value })} placeholder="İsteğe bağlı açıklama" /></div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', marginTop: '0.75rem' }}>
                    <button className="btn btn-primary btn-sm" disabled={yukleniyor || !yeniOgeForm.etiket} onClick={yeniOgeEkle}>Ekle</button>
                    <button className="btn btn-secondary btn-sm" onClick={() => setYeniOgePanel(false)}>İptal</button>
                  </div>
                </div>
              )}

              {/* Mevcut ögeler */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                {dinamikListeler.filter(l => l.liste_anahtar === seciliListe).sort((a,b) => a.sira - b.sira).map(l => (
                  <div key={l.id} style={{ border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', padding: '0.75rem 1rem', opacity: l.aktif ? 1 : 0.5 }}>
                    {duzenleId === l.id ? (
                      <div>
                        <div className="form-grid">
                          <div className="form-group"><label>Etiket *</label><input type="text" value={duzenleForm.etiket} onChange={e => setDuzenleForm({ ...duzenleForm, etiket: e.target.value })} /></div>
                          <div className="form-group"><label>Açıklama</label><input type="text" value={duzenleForm.aciklama} onChange={e => setDuzenleForm({ ...duzenleForm, aciklama: e.target.value })} /></div>
                          <div className="form-group"><label>Sıra</label><input type="number" value={duzenleForm.sira} onChange={e => setDuzenleForm({ ...duzenleForm, sira: parseInt(e.target.value) })} /></div>
                          <div className="form-group"><label>Aktif</label>
                            <select value={duzenleForm.aktif} onChange={e => setDuzenleForm({ ...duzenleForm, aktif: parseInt(e.target.value) })}>
                              <option value={1}>Aktif</option>
                              <option value={0}>Pasif</option>
                            </select>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', marginTop: '0.75rem' }}>
                          <button className="btn btn-primary btn-sm" disabled={yukleniyor} onClick={() => listeSatirKaydet(l.id)}>Kaydet</button>
                          <button className="btn btn-secondary btn-sm" onClick={() => setDuzenleId(null)}>İptal</button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div>
                          <p style={{ fontSize: '14px', fontWeight: '500' }}>{l.etiket} {!l.aktif && <span style={{ fontSize: '11px', color: 'var(--gri-400)' }}>(Pasif)</span>}</p>
                          {l.aciklama && <p style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', marginTop: '2px' }}>{l.aciklama}</p>}
                          <p style={{ fontSize: '11px', color: 'var(--gri-400)', marginTop: '2px' }}>Sıra: {l.sira} | Değer: {l.deger}</p>
                        </div>
                        <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                          <button className="btn btn-secondary btn-sm" onClick={() => { setDuzenleId(l.id); setDuzenleForm({ etiket: l.etiket, aciklama: l.aciklama, sira: l.sira, aktif: l.aktif }); }}>✏️</button>
                          <button className="btn btn-danger btn-sm" onClick={() => listeSatirSil(l.id)}>🗑️</button>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="card" style={{ textAlign: 'center', padding: '3rem', color: 'var(--yazi-ikincil)' }}>
              Soldan bir liste seçin.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default IcerikYonetimiPage;
